import { FunctionComponent } from 'react';
import { WebLink, WebLinkProps } from '../../app-kit/components/WebLink/WebLink';
import styled from 'styled-components';
import { mediaHelper, paletteHelper, radiusHelper, spacingHelper } from '@property.com.au/ui-kit';

type PropertyReportToggleProps = {
  activeItemIndex: number;
  items: WebLinkProps[];
};

const ToggleContainer = styled.div`
  display: inline-flex;
  gap: ${spacingHelper('twoExtraSmall')};
  border-radius: ${radiusHelper('full')};
  background-color: ${paletteHelper('backgroundSecondary')};
  padding: ${spacingHelper('twoExtraSmall')};
`;

const ToggleTab = styled(WebLink)`
  border: none;
  border-radius: ${radiusHelper('full')};
  padding: ${spacingHelper('twoExtraSmall')} ${spacingHelper('twoExtraSmall')};
  color: ${paletteHelper('textSecondary')};
  /* flex-grow and width force toggle tabs to be equal with */
  flex-grow: 1;
  width: 0;

  ${mediaHelper('tabletMin')} {
    /* min-width forces toggle tabs to be equal with on desktop */
    min-width: 160px;
    padding: ${spacingHelper('extraSmall')} ${spacingHelper('large')};
  }

  &:hover {
    border: none;
    background-color: ${paletteHelper('backgroundHoveredSecondary')};
    color: ${paletteHelper('textPrimary')};
  }

  &:active {
    background-color: ${paletteHelper('backgroundPressedSecondary')};
    color: ${paletteHelper('textPrimary')};
  }

  &:focus {
    background-color: ${paletteHelper('backgroundPressedSecondary')};
    color: ${paletteHelper('textPrimary')};
  }

  &:focus-visible {
    outline: 2px solid ${paletteHelper('borderFocused')};
    background-color: ${paletteHelper('backgroundSecondary')};
    color: ${paletteHelper('textSecondary')};
    border: none;
  }

  /* Override to remove the focus ring that construct kit applies to all Link components */
  &:focus-visible::after {
    display: none;
  }
`;

const ActiveToggleTab = styled(ToggleTab)`
  background-color: ${paletteHelper('backgroundPrimary')};
  color: ${paletteHelper('textBrand')};

  &:hover {
    background-color: ${paletteHelper('backgroundPrimary')};
    color: ${paletteHelper('textBrand')};
  }

  &:active {
    background-color: ${paletteHelper('backgroundPrimary')};
    color: ${paletteHelper('textBrand')};
  }

  &:focus {
    background-color: ${paletteHelper('backgroundPrimary')};
    color: ${paletteHelper('textBrand')};
  }
`;

export const PropertyReportToggleCta: FunctionComponent<PropertyReportToggleProps> = ({
  items,
  activeItemIndex,
}) => {
  return (
    <ToggleContainer>
      {items.map((tab, index) =>
        index === activeItemIndex ? (
          <ActiveToggleTab
            {...tab}
            key={tab.title}
            clientSideRouting={false}
            aria-current="page"
            disabled
          />
        ) : (
          <ToggleTab {...tab} key={tab.title} clientSideRouting={false} />
        ),
      )}
    </ToggleContainer>
  );
};
